import {nanoid} from "nanoid";

export const countryOptions = [
    {
        id: nanoid(),
        text: "USA",
        value: "USA"
    },
    {
        id: nanoid(),
        text: "Spain",
        value: "Spain"
    },
    {
        id: nanoid(),
        text: "Germany",
        value: "Germany"
    },
    {
        id: nanoid(),
        text: "France",
        value: "France"
    },
];

export const cityOptions = [
    {
        id: nanoid(),
        text: "New York",
        value: "New York"
    },
    {
        id: nanoid(),
        text: "Chicago",
        value: "Chicago"
    },
    {
        id: nanoid(),
        text: "Madrid",
        value: "Madrid"
    },
    {
        id: nanoid(),
        text: "Munich",
        value: "Munich"
    },
    {
        id: nanoid(),
        text: "Los Angeles",
        value: "Los Angeles"
    },
    {
        id: nanoid(),
        text: "Paris",
        value: "Paris"
    },
];
